export default __webpack_public_path__ + "static/media/BANNER FORMACION.db668111.png";